'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const index = require('./index-8d6fcb04.js');

const locks = new Set();
//
// Prevents body scrolling. Keeps track of which elements requested a lock so multiple levels of locking are possible
// without premature unlocking.
//
function lockBodyScrolling(lockingEl) {
    locks.add(lockingEl);
    document.body.classList.add("sl-scroll-lock");
}
//
// Unlocks body scrolling. Scrolling will only be unlocked once all elements that requested a lock call this method.
//
function unlockBodyScrolling(lockingEl) {
    locks.delete(lockingEl);
    if (locks.size === 0) {
        document.body.classList.remove("sl-scroll-lock");
    }
}

const rgDialogCss = ":root{--rg-color-theme-muted:#d6d6d6;--rg-color-theme-muted-alt:#f4f4f4;--rg-color-theme-primary:#00497a;--rg-color-theme-primary-alt:#0776aa;--rg-color-theme-secondary:#222222;--rg-color-theme-secondary-alt:#2f2f2f;--rg-color-theme-white:#ffffff;--rg-color-theme-white-alt:#e3e3e3;--rg-color-theme-error:#c91d1d;--rg-color-theme-success:#0cae5b;--rg-color-theme-warning:#f7991c;--rg-base-font-family:Gotham A, Gotham B, sans-serif;--rg-base-font-size:12px;--rg-base-font-weight:300;--rg-base-font-color:#222222;--rg-base-font-color-inverse:#ffffff;--rg-link-font-color:var(--rg-color-theme-primary);--rg-link-hover-font-color:var(--rg-color-theme-primary-alt);--rg-heading-font-color:var(--rg-color-theme-primary, initial);--rg-heading-font-weight:500;--rg-heading-h1-font-size:30px;--rg-heading-h1-font-size-large:36px;--rg-heading-h1-line-height:1.3;--rg-heading-h1-line-height-large:1.6;--rg-heading-h4-font-size:16px;--rg-text-lead-font-size:14px;--rg-text-lead-line-height:1.28571429;--rg-text-large-font-size:20px;--rg-text-large-line-height:1.36;--rg-form-fieldset-border:1px solid #d6d6d6;--rg-transition-timing:cubic-bezier(0.2, 1, 0.3, 1);--rg-transition-x-slow:1000ms;--rg-transition-slow:500ms;--rg-transition-medium:250ms;--rg-transition-fast:150ms;--rg-transition-x-fast:50ms;--rg-overlay-background-color:rgba(0, 0, 0, 0.6);--rg-focus-outline:1px solid currentColor;--rg-button-theme-primary:var(--rg-color-theme-primary);--rg-button-theme-secondary:var(--rg-color-theme-secondary);--nav-heading-background-color:var(--rg-color-theme-primary);--nav-heading-border-color:var(--rg-color-theme-primary);--nav-link-background-color:var(--rg-color-theme-primary-alt);--nav-link-color:var(--rg-base-font-color-inverse)}:host{--width:$global-width-xsmall;display:contents}.dialog{position:fixed;top:0;right:0;bottom:0;left:0;overflow-y:auto;z-index:999;padding:22px;padding-top:30px}@media screen and (min-width: 510px){.dialog{padding:22.5px;padding-top:37.5px}}@media screen and (min-width: 900px){.dialog{padding:30px;padding-top:45px}}.dialog[hidden]{display:none}.dialog__panel{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;width:600px;max-width:calc(100% - 0.01px) !important;margin:0 auto;background-color:var(--rg-panel-background-color, white);opacity:0;-webkit-transform:translateY(-100px);transform:translateY(-100px);-webkit-transition-duration:var(--rg-transition-medium);transition-duration:var(--rg-transition-medium);-webkit-transition-timing-function:var(--rg-transition-timing);transition-timing-function:var(--rg-transition-timing);-webkit-transition-property:opacity, -webkit-transform;transition-property:opacity, -webkit-transform;transition-property:opacity, transform;transition-property:opacity, transform, -webkit-transform;border-bottom:4px solid var(--rg-color-theme-primary-alt);min-height:150px;overflow:auto;-webkit-overflow-scrolling:touch}.dialog__panel:focus{outline:none}.dialog--open .dialog__panel{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}.dialog__header{padding:var(--rg-spacing-large, 22px);border-bottom:1px solid var(--rg-color-theme-muted)}.dialog__close{position:absolute;top:22px;right:22px;margin:0}.dialog__body{padding:var(--rg-spacing-large, 22px)}.dialog__footer{padding:var(--rg-spacing-large, 22px)}.dialog:not(.dialog--has-footer) .dialog__footer{display:none}.dialog__overlay{position:fixed;top:0;right:0;bottom:0;left:0;background-color:var(--rg-overlay-background-color, rgba(0, 0, 0, 0.6));opacity:0;-webkit-transition-property:opacity;transition-property:opacity;-webkit-transition-duration:var(--rg-transition-fast);transition-duration:var(--rg-transition-fast);-webkit-transition-timing-function:var(--rg-transition-timing);transition-timing-function:var(--rg-transition-timing)}.dialog--open .dialog__overlay{opacity:1}";

// import { hasSlot } from "../../utils/slot";
let id = 0;
const RgDialog = class {
    constructor(hostRef) {
        index.registerInstance(this, hostRef);
        this.rgShow = index.createEvent(this, "rgShow", 7);
        this.rgAfterShow = index.createEvent(this, "rgAfterShow", 7);
        this.rgHide = index.createEvent(this, "rgHide", 7);
        this.rgAfterHide = index.createEvent(this, "rgAfterHide", 7);
        this.rgOverlayDismiss = index.createEvent(this, "rgOverlayDismiss", 7);
        this.componentId = `dialog-${++id}`;
        this.isShowing = false;
        // @State() hasFooter = false;
        /** Indicates whether or not the dialog is open. You can use this in lieu of the show/hide methods. */
        this.open = false;
        /**
         * The dialog's label as displayed in the header. You should always include a relevant label even when using
         * `no-header`, as it is required for proper accessibility.
         */
        this.label = "";
        /**
         * Set to true to disable the header. This will also remove the default close button, so please ensure you provide an
         * easy, accessible way for users to dismiss the dialog.
         */
        this.noHeader = false;
    }
    handleOpenChange() {
        this.open ? this.show() : this.hide();
    }
    connectedCallback() {
        this.handleDocumentFocusIn = this.handleDocumentFocusIn.bind(this);
        this.handleCloseClick = this.handleCloseClick.bind(this);
        this.handleTransitionEnd = this.handleTransitionEnd.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleOverlayClick = this.handleOverlayClick.bind(this);
        this.updateSlots = this.updateSlots.bind(this);
    }
    componentWillLoad() {
        this.updateSlots();
        this.host.shadowRoot.addEventListener("slotchange", this.updateSlots);
    }
    componentDidLoad() {
        // Show on init if open
        if (this.open) {
            this.show();
        }
    }
    disconnectedCallback() {
        unlockBodyScrolling(this.host);
        this.host.shadowRoot.removeEventListener("slotchange", this.updateSlots);
    }
    /** Shows the dialog */
    async show() {
        // Prevent subsequent calls to the method, whether manually or triggered by the `open` watcher
        if (this.isShowing) {
            return;
        }
        const rgShow = this.rgShow.emit();
        if (rgShow.defaultPrevented) {
            this.open = false;
            return;
        }
        this.dialog.hidden = false;
        this.isShowing = true;
        this.open = true;
        lockBodyScrolling(this.host);
        document.addEventListener("focusin", this.handleDocumentFocusIn);
    }
    /** Hides the dialog */
    async hide() {
        // Prevent subsequent calls to the method, whether manually or triggered by the `open` watcher
        if (!this.isShowing) {
            return;
        }
        const rgHide = this.rgHide.emit();
        if (rgHide.defaultPrevented) {
            this.open = true;
            return;
        }
        this.isShowing = false;
        this.open = false;
        unlockBodyScrolling(this.host);
        document.removeEventListener("focusin", this.handleDocumentFocusIn);
    }
    handleCloseClick() {
        this.hide();
    }
    handleDocumentFocusIn(event) {
        const target = event.target;
        if (target.closest("rg-dialog") !== this.host) {
            this.panel.focus();
        }
    }
    handleKeyDown(event) {
        if (event.key === "Escape") {
            this.hide();
        }
    }
    handleOverlayClick() {
        const rgOverlayDismiss = this.rgOverlayDismiss.emit();
        if (!rgOverlayDismiss.defaultPrevented) {
            this.hide();
        }
    }
    handleTransitionEnd(event) {
        const target = event.target;
        // Ensure we only emit one event when the target element is no longer visible
        if (event.propertyName === "opacity" &&
            target.classList.contains("dialog__panel")) {
            this.dialog.hidden = !this.open;
            this.open ? this.rgAfterShow.emit() : this.rgAfterHide.emit();
            if (this.open) {
                this.panel.focus();
            }
        }
    }
    updateSlots() {
        // this.hasFooter = hasSlot(this.host, "footer");
    }
    render() {
        return (index.h("div", { ref: (el) => (this.dialog = el), part: "base", class: {
                dialog: true,
                "dialog--open": this.open,
            }, onKeyDown: this.handleKeyDown, onTransitionEnd: this.handleTransitionEnd, hidden: true }, index.h("div", { part: "overlay", class: "dialog__overlay", onClick: this.handleOverlayClick }), index.h("div", { ref: (el) => (this.panel = el), part: "panel", class: "dialog__panel", role: "dialog", "aria-modal": "true", "aria-hidden": !this.open, "aria-label": this.noHeader ? this.label : null, "aria-labelledby": !this.noHeader ? `${this.componentId}-title` : null, tabIndex: 0 }, !this.noHeader && (index.h("header", { part: "header", class: "dialog__header" }, index.h("slot", { name: "header" }))), index.h("rg-button", { part: "close-button", class: "dialog__close", type: "text" }, index.h("button", { onClick: this.handleCloseClick, title: "Close" }, index.h("rg-icon", { icon: "zmdi zmdi-close", ratio: 1.725 }))), index.h("div", { part: "body", class: "dialog__body" }, index.h("slot", null)))));
    }
    get host() { return index.getElement(this); }
    static get watchers() { return {
        "open": ["handleOpenChange"]
    }; }
};
RgDialog.style = rgDialogCss;

exports.rg_dialog = RgDialog;
